exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!../colours.icss"), undefined);

// module
exports.push([module.id, ".EmailAuthButton__button___9_-2w {\n    background-color: transparent;\n    height: 2.4rem;\n    margin-bottom: 0.75rem!important;\n}\n\n.EmailAuthButton__label___3M-fF {\n    color: " + require("-!../../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!../colours.icss").locals["inverseMainTextColour"] + ";\n\tdisplay: flex;\n    flex-direction: row;\n}\n\n.EmailAuthButton__text___13vCU {\n\tmin-width: 11rem;\n}\n\n.EmailAuthButton__logo___2do_4 {\n\theight: 1.5rem;\n    margin-right: 1.5rem;\n}\n", ""]);

// exports
exports.locals = {
	"inverseMainTextColour": "" + require("-!../../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!../colours.icss").locals["inverseMainTextColour"] + "",
	"button": "EmailAuthButton__button___9_-2w",
	"label": "EmailAuthButton__label___3M-fF",
	"text": "EmailAuthButton__text___13vCU",
	"logo": "EmailAuthButton__logo___2do_4"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/EmailAuthButton.icss
// module id = 1564
// module chunks = 0